import * as React from 'react';
import image from '../../assets/rob-commcon.jpg';
import TwoSidedLayout from '../layouts/TwoSidedLayout';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import { ArrowForward } from '@mui/icons-material';
import GitHubIcon from '@mui/icons-material/GitHub';
import Link from '@mui/joy/Link';



export default function HeroPage() {
  return (
    <TwoSidedLayout image={image} alt="picture of Rob presenting llm-agent at Commcon 2023" >
      <Typography color="primary" fontSize="lg" fontWeight="lg">
        Aplisay Playground
      </Typography>
      <Typography
        level="h1"
        fontWeight="xl"
        fontSize="clamp(1.875rem, 1.3636rem + 2.1818vw, 3rem)"
      >
        The hosted playground has closed
      </Typography>
      <Typography fontSize="lg" textColor="text.secondary" lineHeight="lg">
        The open source&nbsp;
        <Typography fontSize="lg" textColor="text.primary" lineHeight="lg">llm-agent</Typography> project remains available, but free self-service hosted access is no longer sustainable. For hosted voice agents on real phone numbers, we now run the paid polite.ai beta.
      </Typography>
          <Link fontWeight="lg" href="/signup"><Button size="lg" endDecorator={<ArrowForward fontSize="xl" />}>
            Read the update
          </Button>
          </Link>
      <Typography>
        Been here before? <Link fontWeight="lg" href="/login" variant="outlined">Sign in</Link>
      </Typography>
      <Typography startDecorator={<GitHubIcon />}>
        Back-end&nbsp;<Link fontWeight="lg" href="https://github.com/aplisay/llm-agent" target="_blank" variant="outlined">source code</Link>
      </Typography>

    </TwoSidedLayout >
  );
}
